import {
	comMapping
} from "@/components/util/Function/comMapping";
export function getdata() {
	let obj = {
		searchlist: [{
				prop: "documentNumber",
				label: 'Document Number',
				type: "input",
			}, {
				prop: "vendor",
				label: 'vendor',
				type: "input",
			}, {
				prop: "documentType",
				label: 'Document type',
				type: "select",
				selectval: [],
			}, {
				prop: "documentDate",
				label: 'Document Date',
				type: "date",
				valueformat: 'yyyy-MM-dd'
			}

		],
		searchdata: {
			documentNumber: '',
			vendor: '',
			documentType: '',
			documentDate:[],
		},
		headData: [{
				title: "Document Number",
				prop: "documentNumber",
				width: "160",
				issort: true,
			},
			{
				title: "Vendor",
				prop: "vendor",
				width: "120",
				issort: true,
			},
			{
				title: "Document type",
				prop: "documentType",
				width: "150",
				issort: true,
			},
			{
				title: "Text",
				prop: "test",
				width: "100",
				issort: true,
			},
			{
				title: "Clearing Document",
				prop: "clearingDocument",
				width: "160",
				issort: true,
			},
			{
				title: "Clearing date",
				prop: "clearingDate",
				width: "160",
				issort: true,
			}, {
				title: "Document Date",
				prop: "documentDate",
				width: "160",
				issort: true,
			}, {
				title: "Payment date",
				prop: "paymentDate",
				width: "160",
				issort: true,
			}, {
				title: "G/L Account",
				prop: "glAccount",
				width: "160",
				issort: true,
			}, {
				title: "Purchasing Document",
				prop: "purchasingDocument",
				width: "180",
				issort: true,
			}, {
				title: "Cost Center",
				prop: "costCenter",
				width: "140",
				issort: true,
			}, {
				title: "Profit Center",
				prop: "profitCenter",
				width: "160",
				issort: true,
			}, {
				title: "Amount in local currency",
				prop: "localCurrencyAmount",
				width: "200",
				issort: true,
			}, {
				title: "Local Currency",
				prop: "localCurrency",
				width: "160",
				issort: true,
			}, {
				title: "Tax Code",
				prop: "taxCode",
				width: "140",
				issort: true,
			},
			// {
			// 	title: "操作",
			// 	prop: "cz",
			// 	width: "200",
			// 	custom: true
			// },
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
